import styles from './start-business.module.scss';
import { StartProjectComponent } from '@components/shared/interactions/start-project-component';
import { Themes } from '@layouts/main-layout/themes.enum';
import { Businesstatistics } from './start-buisnes.state';

export type StartBusinessProps = {
  startBusiness: {
    title: string;
    description: string;
  };
  theme?: Themes;
};

const StartBusiness = ({ startBusiness, theme = Themes.DarkGray }: StartBusinessProps) => {
  const statistics = Businesstatistics.statistics;
  const formId = Businesstatistics.formId;
  return (
    <div className={`${styles.container} ${styles[theme]}`}>
      <section className={styles.section}>
        <div className={styles.section__block}>
          <h2 className={styles.section__title}>{startBusiness.title}</h2>
          <p className={styles.section__text}>{startBusiness.description}</p>
          <div className={styles.section__achievements}>
            {statistics.map((item) => (
              <div key={item.label} className={styles.section__achievement}>
                <span className={styles.section__achievement__value}>{item.value}</span>
                <p className={styles.section__achievement__label}>{item.label}</p>
              </div>
            ))}
          </div>
        </div>
        <div id={formId} className={styles.section__form}>
          <StartProjectComponent isSmall={true} />
        </div>
      </section>
    </div>
  );
};

export default StartBusiness;
